import React from 'react';
import UpdatePaymentFormV2 from './UpdatePaymentFormV2';
import { BillingProvider } from '../../../../lib/ContextProviders';
import { RecurlyWrapper } from '../../../../lib/payments';

export interface UpdatePaymentContainerProps {
  onSuccess: () => void;
  onClose: () => void;
}

export const UpdatePaymentFormV2Container = ({
  onSuccess,
  onClose,
}: UpdatePaymentContainerProps) => (
  <RecurlyWrapper>
    <BillingProvider onSuccess={onSuccess}>
      <UpdatePaymentFormV2 onSuccess={onSuccess} onClose={onClose} />
    </BillingProvider>
  </RecurlyWrapper>
);
